/**
 * Api utility handler for the '/explore' endponit.
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import axios from 'axios'
import queryString from 'query-string'
import apiConfig from 'common/configs/api'
import { getHeaders } from 'client/shared/js/services/auth/api'
import roomsData from './rooms.json'

const { apiUrl, explore } = apiConfig

const exploreUrl = `${apiUrl}${explore.url}`
const exploreBoardsUrl = `${exploreUrl}${explore.boards.url}`
const exploreHotelsUrl = `${exploreUrl}${explore.hotels.url}`
const exploreDestinationsUrl = `${exploreUrl}${explore.destinations.url}`
const explorePopularUrl = `${exploreUrl}${explore.popular.url}`

export const getStaycations = (page, size) => {
  const url = queryString.stringifyUrl({
    url: `${exploreBoardsUrl}${explore.boards.staycations}`,
    query: {
      page: page || 0,
      size: size || 9
    }
  })

  return axios.post(url, {}, {
    headers: getHeaders()
  })
}

export const getPopularBoards = (page, size) => {
  const url = queryString.stringifyUrl({
    url: `${exploreBoardsUrl}${explore.boards.popular}`,
    query: {
      page: page || 0,
      size: size || 9
    }
  })

  return axios.post(url, {}, {
    headers: getHeaders()
  })
}

export const getPopularHotels = (checkIn, checkOut) => {
  const url = `${exploreHotelsUrl}${explore.hotels.popular}`

  return axios.post(url, { checkIn, checkOut }, {
    headers: getHeaders()
  })
}

export const getExploreAirbnbListings = (page = 0, size = 9) => {
  // Simulates airbnb api endpoint
  // TODO: Actually implement and call our airbnb api endpoint
  const roomsSlice = roomsData.rooms.slice(page * size, page * size + size)

  const roomsOrder = roomsSlice.map(({ id }) => id)
  const rooms = roomsSlice.reduce((acc, room) => {
    const formattedRoom = { [room.id]: room }
    return {
      ...acc,
      ...formattedRoom
    }
  }, {})
  const res = {
    data: {
      roomsOrder,
      rooms,
      page
    }
  }

  return res
}

export const getDestination = (gpid) => {
  const url = queryString.stringifyUrl({
    url: `${exploreDestinationsUrl}/${gpid}`,
    query: {
      attractions: true,
      boards: true,
      places: false // Disable places for now because we don't have a use
    }
  })

  return axios.get(url, {
    headers: getHeaders()
  })
}

export const getPopularDestinations = () => {
  return axios.get(exploreDestinationsUrl, {
    headers: getHeaders()
  })
}

export const getPopularItems = async () => {
  return axios.get(explorePopularUrl, {
    headers: getHeaders()
  })
}

export default {
  getStaycations,
  getPopularBoards,
  getPopularHotels,
  getExploreAirbnbListings,
  getDestination,
  getPopularDestinations,
  getPopularItems
}
